var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 9.5,
    y: 8,
    width: 8,
    height: 11,
    rx: 2,
    fill: "#5FD0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9V7.5C6.5 6.39543 7.39543 5.5 8.5 5.5H13.75C14.8546 5.5 15.75 6.39543 15.75 7.5V15.5C15.75 16.6046 14.8546 17.5 13.75 17.5H8.5C7.39543 17.5 6.5 16.6046 6.5 15.5L6.5 14M6.5 11.5H13M13 11.5L10.5 8.75M13 11.5L10.5 14.25",
    stroke: "#00212E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.71e5a7472b0ab512ad8b9a572bbbc059.svg";
export { ForwardRef as ReactComponent };